var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDownSmallest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/chevron-down-smallest") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.22922078,8.2365676 C6.53484849,7.92114413 7.0303689,7.92114413 7.33599661,8.2365676 L12,13.0496923 L16.6640034,8.2365676 C16.9418468,7.94981899 17.3766263,7.92375094 17.6830035,8.15836343 L17.7707792,8.2365676 C18.0764069,8.55199107 18.0764069,9.06339355 17.7707792,9.37881702 L12.5533879,14.7634324 C12.2477602,15.0788559 11.7522398,15.0788559 11.4466121,14.7634324 L6.22922078,9.37881702 C5.92359307,9.06339355 5.92359307,8.55199107 6.22922078,8.2365676 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/chevron-down-smallest",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey",
    mask: "url(#mask-2)",
    fill: "#757574"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownSmallest);
export default __webpack_public_path__ + "static/media/chevron-down-smallest.391e51acfac6857a5130f750042e8a2c.svg";
export { ForwardRef as ReactComponent };